export default "__VITE_ASSET__d90773ca__"